import {GET_ACTIVE_MESSAGES_COMPLETE} from '../actions/actionTypes';
import initialState from './initialState';

export default function update(state = initialState.messages, action) {
  if (action.type === GET_ACTIVE_MESSAGES_COMPLETE) {
    return action.payload.messages;
  } else {
    return state;
  }
}